import { Container } from "react-bootstrap";

const Career = () => {
    return(
        <Container className="py-40">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold mb-4 text-gray-800">
          Ready to work where vision meets innovation?
        </h2>
        <p className="text-lg mb-6 text-gray-700">
          Our team pioneers high-performance image-processing hardware, firmware, and software. We're always scouting for engineers who can raise the bar.
        </p>

        <h3 className="text-2xl font-semibold mb-3 text-gray-800">
          How to get on our radar
        </h3>
        <p className="mb-4 text-gray-700">
          Email <a href="mailto:career@kristalfotonik.com" className="text-blue-600 underline">career@kristalfotonik.com</a> with:
        </p>
        <ol className="list-decimal list-inside mb-6 text-gray-700 space-y-2">
          <li>Your résumé (PDF)</li>
          <li>A short note on a project you’re proud of (one paragraph and a link/demo if possible)</li>
        </ol>
        <p className="mb-6 text-gray-700">
          If your profile fits an upcoming opportunity, you’ll be the first to know.
        </p>

        <h3 className="text-2xl font-semibold mb-3 text-gray-800">
          What we work on
        </h3>
        <ul className="list-disc list-inside mb-6 text-gray-700 space-y-1">
          <li>FPGA/GPU-based real-time machine vision pipelines</li>
          <li>Edge-AI acceleration (CNNs, transformers)</li>
          <li>Custom high-speed cameras & optics</li>
        </ul>

        <h3 className="text-2xl font-semibold mb-3 text-gray-800">
          Why it’s worth keeping in touch
        </h3>
        <ul className="list-disc list-inside text-gray-700 space-y-1">
          <li>Impact, not headcount. Small, agile team where your opinion matters.</li>
          <li>Hardware & software synergy. Daily collaboration with optics, electronics and embedded experts.</li>
          <li>Products that ship. Code and boards you design go straight into industrial-grade systems.</li>
        </ul>

        <p className="mt-6 text-gray-700">
          We review every submission and respond if there's a fit—sometimes quickly, sometimes when the next project begins. Either way, your materials are kept confidential.
        </p>
      </div>
    </Container>
    )
}

export default Career;